<template>
<tr>
    <td class="text-center">{{taskIndex}}</td>
    <td>{{taskToProp.taskName}}</td>
    <td class="text-center"><span class="badge" :class = "classColorLevel">{{levelOfTask}}</span></td>
    <td>
      <button 
	  @click = "handleEdit"
      type="button" class="btn mr-md-3 btn-sm btn-warning">Edit</button>
      <button
		@click = "handleDelete"
      type="button" class="btn btn-sm btn-danger">Delete</button>
    </td>
 </tr>

</template>

<script type="text/javascript">
	

	export default{
		name: "todo-list-item",
		props: {
			taskToProp: {type: Object, default: {}},
			taskIndex: {type: Number, default: null}
		},
		data: function(){
			return {

			}
		},
		methods: {
			handleEdit: function(){
				this.$emit("handleEditApp", this.taskToProp);

			},
			handleDelete: function(){
				if(confirm("Do you really want to delete " + this.taskToProp.taskName + " ?")){
					this.$emit("handleDeleteApp", this.taskToProp);						
				}
								
			}
		},
		computed:{
			levelOfTask: function(){
				if(this.taskToProp.level === 2){
					return "High";
				}else if(this.taskToProp.level === 1){
					return "Medium";
				}else{
					return "Low";
				}			
			},

			classColorLevel: function(){
				if(this.taskToProp.level === 0){
					return "badge-danger";
				}else if(this.taskToProp.level === 1){
					return "badge-warning";
				}else{
					return "badge-success";
				}			
			}
		},
		created: function(){
			console.log(this.taskToProp);
		}
	}

</script>

<style type="text/css">
	
button.btn.btn-sm.btn-danger {
    border-radius: 0 10px 0 10px;
}

button.btn.btn-sm.btn-warning {
    border-radius: 0 10px 0 10px;
}
	
</style>